module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/sparks.23ee42d8.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/sparks.png
// module id = 3030
// module chunks = 11